export default __webpack_public_path__ + "static/media/react.60daf01b.png";